<div
  class="container"
  (click)="goToDocumentCenter()">
  @if (isOpen()) {
    <coin-v2-dual-pill
      themeColor="blue"
      icon="fact_check"
      [textRight]="OpenStateName | translate"></coin-v2-dual-pill>
  }
  <div class="image-part empty-image">
    @defer (on viewport) {
      <coin-employee-picture
        size="full"
        [gid]="direct()?.gid"></coin-employee-picture>
    } @placeholder {
      <div style="height: 100%"></div>
    }
  </div>
  <div class="text-part">
    <p class="bold">{{ direct()?.firstname }}</p>
    <p>{{ direct()?.lastname }}</p>
  </div>
</div>
